// @ts-nocheck
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { AI_AGENT_FIELD_LIMITS } from '@/utilities/constant';
import CollapsibleSection from './CollapsibleSection';

const { CONVERSATIONAL_FLOW_MAX } = AI_AGENT_FIELD_LIMITS;

export default function ConversationFlowSection({ value, onChange }: any) {
  return (
    <CollapsibleSection title="Conversation Flow" info="A step-by-step outline of how a call should go. Example: greet, verify the order ID, look up its status.">
      <div className="space-y-4">
        <p className="text-sm font-semibold text-foreground">Conversation Flow</p>
        <p className="mt-1 text-xs text-muted-foreground">
          Describe the conversation flow your agent should follow when interacting with customers.
        </p>

        <div className="space-y-1.5">
          <Label>Description</Label>
          <Textarea
            rows={4}
            placeholder="Describe the conversation flow…"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            maxLength={CONVERSATIONAL_FLOW_MAX}
          />
          <p className="text-right text-xs text-muted-foreground">
            {(value || '').length}/{CONVERSATIONAL_FLOW_MAX}
          </p>
        </div>
      </div>
    </CollapsibleSection>
  );
}
